import React, { useState } from 'react';
import '../../styles/agents.css';
import { Agent } from '../../types/agentTypes';
import AgentConfig from './toggelPanelItem/AgentConfig';
// Removed AgentInfo import as it is no longer used
import AgentConnect from './toggelPanelItem/AgentConnect';
import AgentChannels from './toggelPanelItem/AgentChannels';
import AgentWorkflows from './toggelPanelItem/AgentWorkflows';
import { Settings, MessageSquareText, Workflow } from 'lucide-react';
import AgentPanelHeader from './subComponents/AgentPanelHeader';

interface AgentTogglePanelProps {
    agent: Agent | null;
    isOpen?: boolean;
    onClose?: () => void;
    trainingFlow?: any;
    loadingFlow?: boolean;
    onToggleTraining?: (value: boolean) => void;
    isSavingTraining?: boolean;
    onSaveAgent?: (payload: {
        name?: string;
        shortDescription?: string;
        funnel?: string;
        role?: string;
        objective?: string;
        contraindications?: string;
        notes?: string;
    }) => Promise<void> | void;
    inline?: boolean;
}

const AgentTogglePanel: React.FC<AgentTogglePanelProps> = ({ agent, isOpen: _isOpen, onClose, onSaveAgent, inline }) => {
    const [activeTab, setActiveTab] = useState('config');

    const handleTabChange = (tabId: string) => {
        console.log('[AgentTogglePanel] 🔄 Cambiando tab:', { from: activeTab, to: tabId });
        setActiveTab(tabId);
    };

    const baseTabs = [
        { id: 'config', label: '1. Configuración', icon: Settings },
        { id: 'channels', label: '2. Canales', icon: MessageSquareText },
        { id: 'workflows', label: '3. Flows', icon: Workflow },
    ];

    const allTabs = baseTabs;

    const tabsContent = (
        <div className="agent-toggle-panel-tabs flex gap-2">
            {allTabs.map((tab) => {
                const Icon = tab.icon as any;
                const isActive = tab.id === activeTab;
                return (
                    <button
                        key={tab.id}
                        onClick={() => handleTabChange(tab.id)}
                        className={`flex-1 flex h-10 items-center justify-center gap-2 px-3 rounded-full transition-colors font-montserrat text-sm font-medium ${isActive ? 'bg-primary text-foreground' : 'bg-background text-foreground hover:bg-gray-200'}`}>
                        <Icon className="w-4 h-4 flex-shrink-0" />
                        <span className="truncate text-center block">{tab.label}</span>
                    </button>
                );
            })}
        </div>
    );

    const wrapperClass = `agent-toggle-panel ${inline ? 'agent-toggle-panel--inline' : ''}`;

    return (
        <div className={wrapperClass} onClick={(e) => e.stopPropagation()}>

            {/* Header with centered tabs */}
            <AgentPanelHeader
                agentId={agent?.id}
                agentName={agent?.name}
                onClose={onClose}
                middle={tabsContent}
            />

            {/* Tab Content - scrollable only */}
            <div className="agent-toggle-panel-content">
                {activeTab === 'config' && <AgentConfig agent={agent} onSave={onSaveAgent} />}
                {activeTab === 'channels' && <AgentChannels agentId={agent?.id} />}
                {activeTab === 'workflows' && <AgentWorkflows agentId={agent?.id} />}
                {activeTab === 'connect' && <AgentConnect agent={agent} />}
            </div>
        </div>
    );
};

export default AgentTogglePanel;



